// @flow
import * as React from 'react';
import {useMemo} from 'react';
import Input from "../fieldByType/fieldByType";

type Props = {

};

const RenderField = (props: Props) => {
    const {
        formik,
        field,
        values,
        handleBlur,
        handleChange,
        touched,
        errors
    } = props

    const checkIfFieldVisible = useMemo(() => {
        if (field.type === 'layout_element') return
        if (field.type === 'surname') return
        if (field.type === 'agreeToTerms') return
        return true
    }, [field.enabled, field.type])

    const value = useMemo(() => (
        values &&
        values[field.id]
    ) ? values[field.id] :
        field.fieldType === "select" && field.multiple ? []
            : '', [field.fieldType, field.id, field.multiple, values])
    if (!checkIfFieldVisible) return null
    return (
        <Input
            formik={formik}
            values={values}
            field={field}
            value={value}
            handleBlur={handleBlur}
            handleChange={handleChange}
            touched={touched}
            errors={errors}
        />
    )
};

export default RenderField